import { h } from 'preact';
import Loadable from 'react-loadable';

export default Loadable({
    loader: () => import('../../../../q-cars/src/containers/BikePoint/bikePoint.js'),
    loading: () => <div></div>,
    render(loaded,props) {
        let BikePoint = loaded.default;
        return <BikePoint {...props} />;
    }
});



// WEBPACK FOOTER //
// ../q-cars/src/containers/BikePoint/index.js